import Vue from 'vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

const options = {
    timeout: false,
    closeOnClick: true,
    position: 'top-right',
    icon: true
};
Vue.use(Toast, options);
